import { __awaiter } from "tslib";
import { TimeService } from '../../../service/TimeService';
import { ObjectProcessingNode } from '../../ObjectProcessingNode';
/**
 * Filter processing node for filtering a stream of data.
 * @category Processing node
 */
export class FilterProcessingNode extends ObjectProcessingNode {
  constructor(options) {
    super(options);
  }
  processObject(object, frame) {
    return new Promise((resolve, reject) => {
      // Get existing filter data
      this.getNodeData(object).then(nodeData => __awaiter(this, void 0, void 0, function* () {
        if (nodeData === undefined) {
          nodeData = Object.assign({
            timestamp: TimeService.now()
          }, yield this.initFilter(object, frame, this.options));
        } else if (nodeData['timestamp']) {
          if (nodeData.timestamp + this.options.expire < TimeService.now()) {
            nodeData = Object.assign({
              timestamp: TimeService.now()
            }, yield this.initFilter(object, frame, this.options));
          }
        } else {
          nodeData = Object.assign({
            timestamp: TimeService.now()
          }, nodeData);
        }
        this.filter(object, frame, nodeData, this.options).then(result => {
          resolve(result);
        }).catch(reject).finally(() => {
          this.setNodeData(object, nodeData).then(() => {
            resolve(undefined);
          }).catch(reject);
        });
      })).catch(reject);
    });
  }
}